


























































































































































































































































import { Component } from 'vue-property-decorator';
import moment from 'moment';
import { PaginationModel, VHeaders, VAction } from '@/models/pagedlistmodel';
import { OrphanViewModel, Orphan } from '@/models/filebunker/orphan.attachment';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { expenseService, attachmentService, storeService, vendorService, userService } from '@/shared';
import { typetimeout } from '@/directives/input';
import { mapGetters } from 'vuex';
import { FileUploadDataViewModel } from '@/Alynk.dtos';
import { IFileUploaderOption } from '@/models/fileUploader';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { NotificationType } from '@/helper/enum';
import { appInsights } from '@/main';
@Component({
  props: ['methodName', 'progress'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    VuePdfEmbed,
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),

  },
  computed: {
    ...mapGetters({ currentStoreId: 'getStoreId' }),
  },
  directives: {
    typetimeout,
  },
})
class ExpenseAttachmentPage extends Base {
  public loading: boolean = false;
  public attachmentUri: string = null;
  public fullScreenAttchmentUri: string = null;
  public vendorSearchType: string = 'number'; // number | name
  public vendorSearchInput: string = '';
  public vendorSearchResults: any[] = [];
  // public vendorSelectionDialogOpen: boolean = false;
  public selectedVendorString: string = '';
  public formattedVendorList: string[] = [];

  public scannedInvoiceLoader: boolean = false;
  public invoiceFullScreenLoader: boolean = false;
  public expenseAttachmentLoader: boolean = false;
  public attachments: OrphanViewModel[] = [];
  public attachmentTypes: any = [];
  public paginations = new PaginationModel('attachmentName');
  public storeFilters: any[] = [];
  public storeId: number = 0;
  public showMyInvoices: boolean = true;
  public downloadAttachmentUri: string = null;
  public isPdfLoading: boolean = false;
  public params: any = {
    userEmail: ''
  };
  public files: any = [];
  public attachmentFiles: FileUploadDataViewModel[] = [];
  private vendorRequestId: number = 0;
  public ocrInitiatedAt: string = '';
  public currentStoreId: number;
  public storeLoading: boolean = false;
  public vendorLoader: boolean = false;
  public vendorNumber: string = '';
  public vendorName: string = '';
  public openAttachmentDialog: boolean = false;
  public invoiceFullScreen: boolean = false;
  public users: any = [];
  public routeStoreId: number = 0;
  public fileName: string = '';
  public showAllInvoices: boolean = false;
  public ocrResponseDates: any = [];
  public assignToUserVendorName: string = '';
  public isButlerDefaultOcrProvider: boolean = false;
  public uploadBtnLoading: boolean = false;
  public attachmentTypeToggle: boolean = false;
  public identifier: string = '';
  public identifierLabel: string = 'Deal Number';
  public types = [{ name: 'Deal' }, { name: 'Vehicle' }, { name: 'RO' }];
  public orphanModel: Orphan = {};
  public actions: VAction[] = [];
  public attachmentToSubmit: string;
  public showToggleInvoice: boolean = true;
  public fileUploderRef: string = "expenseAttachmentList";
  public pdfLoadProgress: number = 0;
  public attachmentSize: string = '';
  public currentFileName: string = '';
  public attachmentToResubmit: { attachmentName: string; attachmentUri: string } = {
    attachmentName: '',
    attachmentUri: '',
  };
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
    extensions: ['.pdf']
  };

  public editDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('scannedInvoices.editDialog.title') as string,
    model: false,
    action: {
      color: 'primary',
      icon: 'fas fa-plus',
      text: this.$parent.$t('scannedInvoices.editDialog.btnText') as string,
    },
    loading: false,
    onAction: (): void => {
      this.submitExpense();
    },
  };
  public vendorSelectionDialog: IDialogOption = {
    width: 600,
    title: 'Select Vendor',
    model: false,
    loading: false
  };
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('scannedInvoices.deleteDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('scannedInvoices.deleteDialog.btnText') as string,
    },
    loading: false,
    onAction: (): void => {
      this.deleteAttachmentType();
    },
  };

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }
  public async searchVendor() {
    const requestId = ++this.vendorRequestId;
    this.vendorSearchInput = this.vendorSearchInput?.trim();
    this.vendorName = " ";
    this.vendorNumber = " ";
    if (await this.validateForm()) {
      try {
        this.vendorLoader = true;

        let response;
        if (this.vendorSearchType === 'number') {
          response = await vendorService.getDlVendorAsync(null, this.vendorSearchInput);

        } else {
          response = await vendorService.getDlVendorAsync(this.vendorSearchInput, '0');
        }
        if (requestId !== this.vendorRequestId) return;
        const results = response ?? [];

        if (results.length === 0) {
          this.showAlert(false, 'No vendor found');
          this.vendorNumber = '';
          this.vendorName = '';
          this.moveStatementDialog.action.disable = true;
          return;
        }

        if (results.length === 1) {
          this.vendorNumber = results[0].vendorId;
          this.vendorName = results[0].name;
          this.moveStatementDialog.action.disable = false;
          return;
        }

        this.vendorSearchResults = results;

        this.formattedVendorList = results.map(v =>
          `${v.vendorId} ~ ${v.name}`
        );

        this.selectedVendorString = '';
        this.vendorSelectionDialog.model = true;


      } finally {
        if (requestId === this.vendorRequestId) {
          this.vendorLoader = false;
        }
      }
    }
  }
  public selectVendor(item: any) {
    this.vendorNumber = item.vendorId;
    this.vendorName = item.name;
    this.vendorSelectionDialog.model = false;
    this.moveStatementDialog.action.disable = false;
  }

  public onVendorSelected(value: string) {
    if (!value) return;

    const parts = value.split('~');

    this.vendorNumber = parts[0].trim();
    this.vendorName = parts[1].trim();

    this.vendorSelectionDialog.model = false;
    this.moveStatementDialog.action.disable = false;
  }

  public assignToUserDialog: IDialogOption = {
    width: 600,
    title: "Assign To User",
    model: false,
    action: {
      disable: false,
      color: 'success',
      icon: 'fas fa-check',
      text: "Agree",
    },
    loading: false,
    onAction: (): void => {
      this.assignInvoiceToUser();
    },
  };

  public moveDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('scannedInvoices.moveDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('scannedInvoices.moveDialog.btnText') as string,
    },
    loading: false,
    onAction: (): void => {
      this.moveAttachment();
    },
  };
  public moveQueueDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('scannedInvoices.moveQueueDialog.title') as string,
    model: false,
    action: {
      disable: true,
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'scannedInvoices.moveQueueDialog.btnText'
      ) as string,
    },
    loading: false,
    onAction: (): void => {
      this.moveQueueAttachment();
    },
  };
  public moveStatementDialog: IDialogOption = {
    width: 600,
    title: 'Move to Statements',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Agree',
      disable: true
    },
    loading: false,
    onAction: (): void => {
      this.moveToStatement();
    },
  };

  public ocrHistoryDialog: IDialogOption = {
    width: 600,
    title: "OCR History",
    model: false,
    loading: false,
  };


  public async openInvoiceFullScreen() {

    this.invoiceFullScreenLoader = true;
    this.fullScreenAttchmentUri = await this.getAttachmentByFileName(this.currentFileName);
    this.openAttachmentDialog = false;
    this.invoiceFullScreenLoader = false;
    this.invoiceFullScreen = true;

  }

  public checkStores(): boolean {
    return this.storeId == null || this.storeId === 0;
  }
  public checkEmail(): boolean {
    return this.params.userEmail === null || this.params.userEmail === '';
  }
  public headers: VHeaders[] = [

    // {
    //   text: this.$parent.$t('scannedInvoices.gridHeaders.action') as string,
    //   isNotDataProp: true,
    //   align: 'center',
    //   sortable: false,
    //   isActionsOnLeft: true
    // },
    // {
    //   text: this.$parent.$t('scannedInvoices.gridHeaders.name') as string,
    //   align: 'left',
    //   value: 'attachmentName',
    //   visible: (item: any) => {
    //     return false;
    //   },
    //   // rowStyle: (item: any): string => {
    //   //   return item.invoiceExists ? 'background-color:#ed5c5c' : '';
    //   // }
    // },
    {
      text: this.$parent.$t('scannedInvoices.gridHeaders.vendorName') as string,
      align: 'left',
      value: 'vendorName',
    },
    {
      text: 'Vendor Address',
      align: 'left',
      value: 'vendorAddress',
    },
    {
      text: this.$parent.$t('scannedInvoices.gridHeaders.pONumber') as string,
      align: 'left',
      value: 'poNumber',
      fieldType: 'template',
      template: (item) => {
        if (item.invoiceExists && item.poNumber) {
          return `<span style="background-color: red; color: white; padding: 2px 4px; border-radius: 4px;">${item.poNumber}</span>`;
        } else if (item.poNumber) {
          return `<span>${item.poNumber}</span>`;
        } else {
          return `<span>N/A</span>`;
        }
      }
    },
    {
      text: 'Invoice Number',
      align: 'left',
      value: 'invoiceNumber',
      fieldType: 'template',
      template: (item) => {
        if (item.invoiceExists && item.invoiceNumber) {
          return `<span style="background-color: red; color: white; padding: 2px 4px; border-radius: 4px;">${item.invoiceNumber}</span>`;
        } else if (item.invoiceNumber) {
          return `<span>${item.invoiceNumber}</span>`;
        } else {
          return `<span>N/A</span>`;
        }
      }
    },
    // {
    //   text: 'Invoice Number',
    //   align: 'left',
    //   value: 'invoiceNumber',
    // },
    {
      text: 'Invoice Date',
      align: 'left',
      value: 'invoiceDate',
    },
    {
      text: 'Invoice Total',
      align: 'left',
      value: 'invoiceTotal',
    },
    // {
    //   text: 'Remit To Name',
    //   align: 'left',
    //   value: 'remitToName',
    // },
    // {
    //   text: 'Remit To Address',
    //   align: 'left',
    //   value: 'address',
    // },
    // {
    //   text: 'Vendor Phone Number',
    //   align: 'left',
    //   value: 'phoneNumber',
    // },
    {
      text: "Scan Assignment",
      align: 'left',
      value: 'defaultApScanUser',
    },
    // {
    //   text: this.$parent.$t(
    //     'scannedInvoices.gridHeaders.vendorNumber'
    //   ) as string,
    //   align: 'left',
    //   value: 'vendorNumber',
    // },
    {
      text: this.$parent.$t(
        'scannedInvoices.gridHeaders.lastModified'
      ) as string,
      align: 'left',
      value: 'lastModified',
      fieldType: 'date',
    },
    {
      text: this.$parent.$t('scannedInvoices.gridHeaders.status') as string,
      align: 'center',
      value: 'metadata',
      fieldType: 'template',
      template: (item) => {
        const status = item.metadata?.OcrStatus ?? item.metadata?.Ocrstatus ?? 'Pending';

        const normalizedStatus = status.toLowerCase();

        const showVendorMappingLink =
          normalizedStatus.includes('multiple vendors found') ||
          normalizedStatus.includes('ocr mapping is not configured');
          
        if (showVendorMappingLink) {
          return `
        <div>
          <div>${status}</div>
          <a
            href="/app/vendors/storevendors"
            target="_blank"
            style="color:#1976d2;text-decoration:underline;"
          >
            Configure Vendor Mapping
          </a>
        </div>
      `;
        }

        return `<span>${status}</span>`;
      },
    },
    {
      text: this.$parent.$t('scannedInvoices.gridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        loading: false,
        action: (model: OrphanViewModel, action: any) => {
          model.action = "Delete";
          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
          this.showDeleteDialog(model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.view'
        ) as string,
        loading: false,
        action: (model: OrphanViewModel, action: any) => {
          this.openAttachment(model.attachmentName, model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-download',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.download'
        ) as string,
        loading: false,
        action: (model: OrphanViewModel, action) => {
          this.downloadFile(model.attachmentUri, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-cut',
        title: 'Split Invoice',
        loading: false,
        action: (model: OrphanViewModel, action) => {

          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
            this.viewSplitPdf(model, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-receipt',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.submitExpense'
        ) as string,
        action: (model: OrphanViewModel) => {

          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
            this.submitExpenseDialog(model.attachmentUri);
          
        },
      },
      {
        type: 'button',
        icon: 'fas fa-copy',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.moveToOrphan'
        ) as string,
        action: (model: OrphanViewModel) => {
          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
          this.showOrphanDialog(model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-copy',
        title: this.$parent.$t(
          'scannedInvoices.gridHeaders.gridAction.moveToQueueOrphan'
        ) as string,
        action: (model: OrphanViewModel) => {
          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
          this.showMoveQueueConfirmationDialog(model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-copy',
        title: 'Move to Statements',
        action: (model: OrphanViewModel) => {
          if (!this.canProceedWithExpenseAction(model)) {
            return;
          }
          this.showMoveStatementConfirmationDialog(model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fa-share',
        title: "Assign User",
        color: 'primary',
        loading: false,
        action: (model: any, action: any) => {
          this.showAssignToUserDialog(model.attachmentUri, model.vendorName);
        },
      },
      {
        type: 'button',
        icon: 'fa-history',
        title: "OCR History",
        color: 'primary',
        loading: false,
        action: (model: OrphanViewModel, action: any) => {
          this.showOcrHistoryDialog(model.attachmentName);
        },
      },
      {
        type: 'button',
        icon: 'fa fa-file-text',
        title: "Re Map Invoice",
        color: 'primary',
        loading: false,
        visible: (model: OrphanViewModel) => {
          if (model.documentId != undefined && model.documentId != "" && this.isButlerDefaultOcrProvider) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: OrphanViewModel, action: any) => {
          var startIndex = model.attachmentUri.indexOf('/privatedocs');
          var endIndex = model.attachmentUri.length;
          var attachmentUri = model.attachmentUri.substring(startIndex, endIndex);

          this.$router.push({
            name: "app.expenses.document",
            params: {
              uri: attachmentUri,
              documentId: model.documentId,
              impiraUid: model.impiraUid
            }
          });
        },
      },
      // {
      //   type: 'button',
      //   icon: 'fa fa-camera-retro',
      //   title: "Retry Ocr",
      //   color: 'primary',
      //   loading: false,
      //   action: (model: OrphanViewModel, action: any) => {
      //     var startIndex = model.attachmentUri.indexOf('/privatedocs');
      //     var endIndex = model.attachmentUri.length;
      //     var attachmentUri = model.attachmentUri.substring(startIndex, endIndex);

      //     expenseService.RetrySaveExpenseOcr(this.userSession.tenantId, this.userSession.enterpriseId,
      //       this.userSession.storeId, attachmentUri, model.impiraUid);
      //     this.showAlert(true, 'Ocr Done Successfully');
      //   },
      // },

      {
        type: 'button',
        icon: 'fas fa-download',
        title: "Download Orignal",
        loading: false,
        visible: (model: OrphanViewModel) => {
          if (model.originalFileName && model.originalAttachmentUri) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: OrphanViewModel, action) => {
          this.downloadFile(model.originalAttachmentUri, action);
        },
      },
      {
        type: 'button',
        icon: 'fa fa-pencil-square-o',
        title: "Annotate Invoice",
        loading: false,
        visible: (model: OrphanViewModel) => { // @ts-ignore
          if (model.metadata && model.metadata.OcrStatus != 'IN_PROCESS') {
            return true;
          } else {
            return false;
          }
        },
        action: (model: OrphanViewModel, action: any) => {
          this.$router.push({
            name: "app.expenses.annotateinvoice",
            params: {
              uri: model.attachmentUri.substring(model.attachmentUri.indexOf("Schomp/"), model.attachmentUri.length),
              attachmentName: model.attachmentName,
            }
          });
        },
      },
      {
        type: 'button',
        icon: 'fa fa-qrcode',
        title: "Resubmit OCR",
        loading: false,
        visible: (model: OrphanViewModel) => { // @ts-ignore
          const metadata = model?.metadata ?? {};
          const ocrStatus = (metadata['OcrStatus'] ?? '').toLowerCase();

          if (model.metadata && (ocrStatus == 'failed' || ocrStatus == 'pending' || ocrStatus.includes("multiple vendors found or ocr mapping is not configured"))) 
            return true;
          else
            return false;
        },
        action: (model: OrphanViewModel, action: any) => {
          this.attachmentToResubmit.attachmentName = model.attachmentName;
          this.attachmentToResubmit.attachmentUri = model.attachmentUri;

          this.confirmInvoiceResubmitDialog.model = true;
        },
      },
      // {
      //   type: 'button',
      //   icon: 'fa fa-pencil-square-o',
      //   title: "Save Expense Ocr",
      //   loading: false,
      //   action: (model: OrphanViewModel, action: any) => {
      //     this.saveExpenseOcr(model);

      //   },
      // }
    ];
  }

  // public saveExpenseOcr(model) {
  //   try {
  //     expenseService.saveExpenseOcrDetails(model.attachmentUri, model.documentId);
  //   }
  //   catch {

  //   }
  // }

  public async resubmitInvoiceAttachment()
  {
    try{
      this.confirmInvoiceResubmitDialog.loading = true;
      var response = await expenseService.resubmitInvoice(this.attachmentToResubmit.attachmentName, this.attachmentToResubmit.attachmentUri);
      if(response.status){
        this.showNotification(NotificationType.Success, response.responseMessage);
        this.confirmInvoiceResubmitDialog.loading = false;
        this.confirmInvoiceResubmitDialog.model = false;

        await this.getOrphanAttachments();
      }
      else
        this.showNotification(NotificationType.Error, response.responseMessage);
    }
    finally{
      this.confirmInvoiceResubmitDialog.loading = false;
      this.confirmInvoiceResubmitDialog.model = false;
    }
  }

  public showOcrHistoryDialog(attachmentName) {
    try {
      var response = this.attachments.filter(x => x.attachmentName == attachmentName)[0];
      var isOcrResponse = response.hasOwnProperty('ocrResponseReceivedAt');

      if (isOcrResponse) {
        this.ocrResponseDates = response.ocrResponseReceivedAt.split(',');
        this.ocrResponseDates.reverse();

        this.ocrInitiatedAt = response.ocrInitiatedAt;
        this.ocrHistoryDialog.model = true;
      } else {
        this.showAlert(false, "No OCR History Available");
      }

    } finally {

    }
  }

  private canProceedWithExpenseAction(model: OrphanViewModel): boolean {
    const metadata = model?.metadata ?? {};

    const ocrStatus = (metadata['OcrStatus'] ?? '').toLowerCase();
    const autoDraftStatus = (metadata['AutoDraftStatus'] ?? '').toLowerCase();

    if (ocrStatus === 'pending' && model.action != "Delete") {
      this.showNotification(
        NotificationType.Warning,
        'Please wait, OCR is in progress'
      );

      return false;
    }
    else if(ocrStatus === 'pending' && model.action == "Delete")
    {
      var ocrInitAt = (metadata['OcrInitAt'] ?? '').toLowerCase();
      var canDeleteInvoice = this.ocrTimeSinceInitiated(ocrInitAt);
      if(canDeleteInvoice) return canDeleteInvoice;
      
      this.showNotification(NotificationType.Warning, 'Please wait, OCR is in progress');
      return false;
    }

    if (ocrStatus === 'success' && autoDraftStatus === 'pending') {
      this.showNotification(
        NotificationType.Warning,
        'Please wait, expense auto-draft is in progress'
      );

      return false;
    }

    if (autoDraftStatus === 'success') {
      this.showNotification(
        NotificationType.Warning,
        'Expense has already been auto-drafted.'
      );

      return false;
    }

    return true;
  }

  public ocrTimeSinceInitiated(ocrInitAt:string): boolean {
    // Try to parse ocrInitiatedAt as ISO or fallback to local
    ocrInitAt = ocrInitAt.trim();
    const start = moment(
      ocrInitAt,
      [
        moment.ISO_8601,
        'MM/DD/YYYY HH:mm:ss',
        'M/D/YYYY h:mm:ss a Z',
        'DD-MMM-YY hh:mm:ss A Z'
      ],
      true
    );
    const now = this.$moment();
    const duration = now.diff(start, 'minutes');

    if(duration > 40) return true;

    return false;
  }

  public callMethod(methodName): void {
    if (methodName === 'getVendorInfo') {
      this.getVendorInfo();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'scannedInvoices');
    this.storeId = this.userSession.storeId;
    if (this.$route.query.name != undefined && this.$route.query.index != undefined) {
      this.fileName = this.$route.query.name.toString();
      this.routeStoreId = Number(this.$route.query.index);
      this.showAllInvoices = false;
      this.showToggleInvoice = true;
    } else {
      this.showToggleInvoice = false;
    }
    this.getOrphanAttachments();
    this.addWatchers();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
    this.getStores();
    this.getUsersByRole();
  }

  public addWatchers(): void {
    // this.$watch('vendorName', (newVal) => {
    //   this.moveStatementDialog.action.disable = !newVal;
    // });
    this.$watch(
      () => this.storeId,
      () => {
        this.moveQueueDialog.action.disable = this.checkStores();
      },
      { immediate: true }
    );

    this.$watch(
      () => this.params.userEmail,
      () => {
        this.assignToUserDialog.action.disable = this.checkEmail();
      },
      { immediate: true }
    );
  }

  public async getUsersByRole(): Promise<void> {
    try {
      const accountPayableUsers = await userService.getStoreUsersByRole(this.currentStoreId, "AP");
      this.users = accountPayableUsers.results;
    } finally {

    }
  }

  public async assignInvoiceToUser(): Promise<void> {
    try {
      this.assignToUserDialog.loading = true;
      var param = this.orphanModel.attachmentUri.split('/privatedocs')[1];
      var uri = '/privatedocs' + param;
      await userService.assignInvoiceToUser(uri, this.params.userEmail, this.assignToUserVendorName);
      this.showAlert(true, "Successfully Assigned to User");
    } finally {
      this.assignToUserDialog.loading = false;
      this.assignToUserDialog.model = false;
      this.assignToUserVendorName = "";
    }
  }
  public onPdfRendered() {
    this.isPdfLoading = false;
  }

  public toggleAsignInvoice() {
    if (this.showAllInvoices) {
      this.fileName = '';
      this.routeStoreId = 0;
    }
    else if (this.$route.query.name != undefined && this.$route.query.index != undefined) {
      this.fileName = this.$route.query.name.toString();
      this.routeStoreId = Number(this.$route.query.index);

    }
    this.getOrphanAttachments();
  }

  public async getOrphanAttachments(): Promise<void> {
    try {
      this.loading = true;
      const attachment = await expenseService.getOrphanAttachmentsAsync(this.fileName, this.routeStoreId, this.showMyInvoices);
      this.attachments = attachment.results;
      this.paginations.totalItems = attachment.results.length;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: PaginationModel) {
    this.paginations = paging;
  }
  public async submitExpense(): Promise<void> {
    if (this.attachmentToSubmit) {
      try {
        this.editDialog.loading = true;
        const response = await expenseService.submitExpenseAttachmentAsync(
          this.attachmentToSubmit
        );
        this.editDialog.model = false;
        this.showAlert(true, response.responseMessage);
        this.$router.push({
          name: 'app.expenses.edit',
          params: { expenseId: String(response.id), mode: 'edit' },
        });

        this.getOrphanAttachments();
      } finally {
        this.editDialog.loading = false;
      }
    } else {
      this.showAlert(false, this.$t('scannedInvoices.alertTryAgain'));
    }
  }
  public async getAttachmentByFileName(name: string) {
    var response = await attachmentService.getAttachmentByFileNameAsync(name);
    this.attachmentSize = (response.fileSize / (1024 * 1024)).toFixed(2);
    this.isPdfLoading = true;
    return response.filePublicUri;
  }
  public async openAttachment(name: string, uri: string): Promise<void> {
    try {
      if (name) {
        this.expenseAttachmentLoader = true;
        this.currentFileName = name;
        this.downloadAttachmentUri = uri;
        this.attachmentUri = await this.getAttachmentByFileName(name);
        this.openAttachmentDialog = true;
      } else {
        this.showAlert(false, this.$t('scannedInvoices.alertUriNotFound'));
      }
    } finally {
      this.expenseAttachmentLoader = false;
    }
  }

  public async downloadAttachment(): Promise<void> {
    try {
      const attachment = await attachmentService.viewAttachmentByUriAsync(
        this.downloadAttachmentUri
      );
      this.openAttachmentDialog = false;
    } finally {
      this.expenseAttachmentLoader = false;

    }
  }

  public async downloadFile(attachmentUri: string, action: any): Promise<void> {
    try {
      action.loading = true;
      this.scannedInvoiceLoader = true;
      const attachment = await expenseService.downloadAttachmentAsync(
        attachmentUri
      );
      const bytes = _file.base64ToArrayBuffer(attachment.fileContents);

      _file.downloadBytes(bytes, '', attachment.fileDownloadName);
    } catch (e) {
      this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
    } finally {
      this.scannedInvoiceLoader = false;
      action.loading = false;
    }
  }

  public async viewSplitPdf(model: any, action: any): Promise<void> {
    try {
      action.loading = true;
      this.scannedInvoiceLoader = true;
      var fileDetails = model.attachmentUri.split('/');
      var fileName = fileDetails[fileDetails.length - 1];
      this.$router.push({
        name: 'app.expenses.invoice.split',
        params: { attachmentName: fileName },
      });
    } catch (e) {
      this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
    } finally {
      this.scannedInvoiceLoader = false;
      action.loading = false;
    }
  }

  public submitExpenseDialog(attachmentUri: string): void {
    this.editDialog.model = true;
    this.attachmentToSubmit = attachmentUri;
  }

  public showDeleteDialog(uri: string) {
    this.orphanModel.attachmentUri = uri;
    this.deleteDialog.model = true;
  }

  public showAssignToUserDialog(uri: string, vendorName: string) {
    this.orphanModel.attachmentUri = uri;
    this.params.userEmail = '';
    this.assignToUserVendorName = vendorName ? vendorName : "";
    this.assignToUserDialog.model = true;
  }

  public async deleteAttachmentType(): Promise<void> {
    try {
      if (this.orphanModel.attachmentUri) {
        appInsights.trackTrace({message: `Scanned Invoice: Delete Invoice - ${this.orphanModel.attachmentUri}`});

        this.deleteDialog.loading = true;
        await expenseService.deleteAttachmentByUri(
          this.orphanModel.attachmentUri
        );
        this.deleteDialog.model = false;
        this.showAlert(
          true,
          this.$t('scannedInvoices.alertAttachmentTypeRemoved')
        );
        this.getOrphanAttachments();
      } else {
        this.showAlert(
          false,
          this.$t('scannedInvoices.alertAttachmentUriNotFound')
        );
      }
    } finally {
      this.deleteDialog.loading = false;
    }
  }

  public closeDialog() {
    this.editDialog.model = false;
  }

  public showOrphanDialog(attachmentUri: string): void {
    this.moveDialog.model = true;
    this.attachmentToSubmit = attachmentUri;
  }

  public showMoveQueueConfirmationDialog(attachmentUri: string): void {
    this.moveQueueDialog.model = true;
    this.storeId = 0;
    this.attachmentToSubmit = attachmentUri;
  }

  public showMoveStatementConfirmationDialog(attachmentUri: string): void {
    this.vendorRequestId++;
    this.vendorLoader = false;
    this.$validator.reset();
    this.vendorName = '';
    this.vendorNumber = '';
    this.vendorSearchInput = '';
    this.vendorSearchResults = [];
    this.vendorSearchType = 'number';
    this.moveStatementDialog.action.disable = true;
    this.moveStatementDialog.model = true;
    this.attachmentToSubmit = attachmentUri;

  }

  public async moveAttachment() {
    if (this.attachmentToSubmit) {
      try {
        this.moveDialog.loading = true;
        appInsights.trackTrace({message: `Scanned Invoice: Move Invoice to Orphan - ${this.attachmentToSubmit}`});

        await expenseService.moveAttachmentToOrphanAsync(
          this.attachmentToSubmit
        );
        this.showAlert(true, this.$t('scannedInvoices.alertAttachmentMoved'));
        this.getOrphanAttachments();
      } finally {
        this.moveDialog.loading = false;
        this.moveDialog.model = false;
      }
    } else {
      this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
    }
  }
  public async moveToStatement() {
    if (!(await this.validateFormByScope('vendorStatement'))) {
      return;
    }
    if (this.attachmentToSubmit) {
      try {
        this.moveStatementDialog.loading = true;
        appInsights.trackTrace({message: `Scanned Invoice: Move Invoice to Vendor Statement - ${this.attachmentToSubmit}, Vendor Number - ${this.vendorNumber}`});
        
        await expenseService.moveToStatementAsync(this.attachmentToSubmit, this.vendorNumber);
        this.showAlert(true, 'Attachment Moved');
        this.getOrphanAttachments();
        this.vendorNumber = '';
        this.vendorName = '';
        this.$validator.reset();
      }
      finally {
        this.moveStatementDialog.loading = false;
        this.moveStatementDialog.model = false;
      }
    }
    else {
      this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
    }
  }

  public async getStores(): Promise<void> {
    try {
      this.storeLoading = true;
      const response = await storeService.getUserStoresList();
      this.storeFilters = response.results;
      const storeData = await storeService.getStore(
        Number(this.storeId),
      );
      if (storeData && storeData.storeJson) {
        this.isButlerDefaultOcrProvider = storeData.storeJson.defaultOcrProvider == "Butler";
      }
    } finally {
      this.storeLoading = false;
    }
  }

  public async moveQueueAttachment() {
    if (!this.storeId) {
      this.showAlert(false, this.$t('scannedInvoices.alertStoreNotFound'));
      return;
    }
    if (this.attachmentToSubmit) {
      try {
        this.moveQueueDialog.loading = true;
        appInsights.trackTrace({message: `Scanned Invoice: Move Invoice to Another Queue - ${this.attachmentToSubmit}`});

        await expenseService.moveAttachmentToQueueOrphanAsync(
          this.attachmentToSubmit,
          this.storeId
        );
        this.showAlert(true, this.$t('scannedInvoices.alertAttachmentMoved'));
        this.getOrphanAttachments();
      } catch (ex) {
        console.log(ex);
      } finally {
        this.moveQueueDialog.loading = false;
        this.moveQueueDialog.model = false;
      }
    } else {
      this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
    }
  }

  public resetVendorFields() {
    this.vendorSearchInput = '';
    this.vendorNumber = '';
    this.vendorName = '';
    this.moveStatementDialog.action.disable = true;
  }

  public async getVendorInfo() {
    try {
      this.vendorLoader = true;
      const vendor = await vendorService.getDlVendorAsync(
        null, this.vendorNumber
      );
      this.vendorName = vendor[0].name;
    } finally {
      this.vendorLoader = false;
    }
  }

  public confirmUpload(): void {
    if (this.attachmentFiles.length == 0) {
      this.showAlert(false, this.$t('vehicleReviveAttachment.alertSelectFileForUpload'));
      return;
    }

    this.uploadDialog.model = true;
  }

  public uploadDialog: IDialogOption = {
    width: 400,
    title: 'Confirm',
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.UploadAttachment();
    },
  };

   public confirmInvoiceResubmitDialog: IDialogOption = {
    width: 500,
    title: 'Confirm',
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: async (): Promise<void> => {
      await this.resubmitInvoiceAttachment();
    },
  };

  public async UploadAttachment() {
    if (this.attachmentFiles.length > 0) {
      try {
        this.uploadDialog.loading = true;
        this.uploadBtnLoading = true;
        var message = await expenseService.uploadInvoiceAttachment(this.attachmentFiles);
        if(message?.responseStatus?.message != undefined && message?.responseStatus?.message != "")
        {
          this.showNotification(NotificationType.Warning, message?.responseStatus?.message);
          return;
        }
        
        this.showAlert(true, 'Invoice has been successfully uploaded and queued for ocr, please check after some time');
        this.files = [];

        this.attachmentFiles = [];
        this.files = [];
        this.getOrphanAttachments();
        this.$root.$emit('resetFileList', this.fileUploderRef);
      } finally {
        this.uploadDialog.loading = false;
        this.uploadDialog.model = false;
        this.uploadBtnLoading = false;
      }
    }
  }
}

export default ExpenseAttachmentPage;

